module.exports = __webpack_public_path__ + "static/sizzle_desktop-a8acbbd212eca5daebca9dbd6ea10f8a.mp4";